import ProductCodeSearch from '@components/v2/layout/AppTemplate/components/ProductSearch/ProductCodeSearch';
import { Box } from '@mui/material';
import BrandSelectModal from '../../../../modules/brand/BrandSelectModal';
import VoucherMenu from '../../../../modules/business-policies/components/VoucherMenu/VoucherMenu';
import GlobalSearchProvider from '../../../../modules/global-search/GlobalSearchProvider';
import GlobalSearchTrigger from '../../../../modules/global-search/GlobalSearchTrigger';
import OrderBookModal from '../../../../modules/order-book/OrderBookModal';
import OrderActiveMenu from '../../../../modules/order-book/components/OrderActiveMenu/OrderActiveMenu';
import { SHOW_TOPBAR_ADD_PRODUCT } from '../../../../modules/orders/orders.constants';
import RachelTrigger from '../../../../modules/rachel/components/RachelTrigger';
import BrandSelectorTrigger from '../BrandSelector/BrandSelectorTrigger';
import BackToCatalogTrigger from './components/BackToCatalogTrigger/BackToCatalogTrigger';
import NavigationLogo from './components/NavigationLogo/NavigationLogo';
import ShowUnavailableProductsTrigger from './components/ShowUnavailableProductsTrigger/ShowUnavailableProductsTrigger';
import useHomeNavigationHeader from './hooks/useHomeNavigationHeader';

const HomeNavigationHeader = () => {
  const {
    canSelectBrand,
    isInStoreEnvironment,
    verifyBrandContext,
    canCreateOrders,
    brandModal,
    selectBrand,
    brands,
  } = useHomeNavigationHeader();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        gap: (theme) => theme.spacing(1),
        marginLeft: (theme) => theme.spacing(1),
      }}
    >
      <NavigationLogo />
      {canSelectBrand && <BrandSelectorTrigger />}
      <GlobalSearchProvider>
        <Box
          sx={{
            ml: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: (theme) => theme.spacing(1),
          }}
        >
          <GlobalSearchTrigger />
          <VoucherMenu />
          <ShowUnavailableProductsTrigger />
          <RachelTrigger />
          {!isInStoreEnvironment && (
            <>
              {SHOW_TOPBAR_ADD_PRODUCT && canCreateOrders && (
                <ProductCodeSearch mode="add" verifyBrandContext={verifyBrandContext} />
              )}
              {canCreateOrders && <OrderBookModal />}
              <BackToCatalogTrigger />
              {canCreateOrders && <OrderActiveMenu verifyBrandContext={verifyBrandContext} />}
              <BrandSelectModal
                open={brandModal.isOpen}
                onClose={brandModal.closeModal}
                onClick={(brand) => {
                  selectBrand(brand);
                  brandModal.closeModal();
                }}
                brands={brands}
              />
            </>
          )}
        </Box>
      </GlobalSearchProvider>
    </Box>
  );
};

export default HomeNavigationHeader;
